import * as React from "react";
const ProfitabilityActive = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="iconmonstr-coin-8 1" clipPath="url(#clip0_940_162271)">
      <path
        id="Vector"
        d="M13.0925 10.0114C18.5814 10.0114 23.3617 7.9421 23.3617 5.3902C23.3617 2.83829 18.5814 0.769043 13.0925 0.769043C7.6046 0.769043 2.82324 2.83829 2.82324 5.3902C2.82324 7.9421 7.6046 10.0114 13.0925 10.0114ZM13.2845 5.88415C12.6704 5.6993 10.7911 5.54321 10.7911 4.4978C10.7911 3.91451 11.4771 3.39489 12.7597 3.27884V2.82289H13.419V3.25625C13.8996 3.26755 14.4347 3.31992 15.0303 3.4411L14.79 4.14454C14.3371 4.04082 13.8319 3.94018 13.3359 3.94018L13.1869 3.94224C12.199 3.98331 12.1179 4.53169 12.8039 4.76275C13.9253 5.10882 15.4041 5.3635 15.4041 6.28157C15.4041 7.01479 14.5137 7.4081 13.418 7.50566V7.9575H12.7587V7.5303C12.082 7.52414 11.3693 7.41426 10.7819 7.21812L11.0848 6.51365C11.586 6.64202 12.2165 6.77346 12.7844 6.77346C12.9333 6.77346 13.076 6.76422 13.2126 6.74471C13.9695 6.63585 14.1204 6.1265 13.2845 5.88415ZM13.0925 22.3344C16.9773 22.3344 21.008 21.3393 23.3617 19.456V20.794C23.3617 23.3459 18.5814 25.4152 13.0925 25.4152C7.6046 25.4152 2.82324 23.3459 2.82324 20.794V19.4549C5.17695 21.3393 9.20762 22.3344 13.0925 22.3344ZM13.0925 12.0652C16.9773 12.0652 21.008 11.0701 23.3617 9.18673V10.5248C23.3617 13.0767 18.5814 15.146 13.0925 15.146C7.6046 15.146 2.82324 13.0767 2.82324 10.5248V9.18673C5.17695 11.0701 9.20762 12.0652 13.0925 12.0652ZM13.0925 17.1998C16.9773 17.1998 21.008 16.2047 23.3617 14.3213V15.6594C23.3617 18.2113 18.5814 20.2806 13.0925 20.2806C7.6046 20.2806 2.82324 18.2113 2.82324 15.6594V14.3203C5.17695 16.2047 9.20762 17.1998 13.0925 17.1998Z"
        fill="url(#paint0_linear_940_162271)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_940_162271"
        x1={13.0925}
        y1={0.769043}
        x2={13.0925}
        y2={25.4152}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1AB3FF" />
        <stop offset={1} stopColor="#FFB258" />
      </linearGradient>
      <clipPath id="clip0_940_162271">
        <rect
          width={24.6462}
          height={24.6462}
          fill="white"
          transform="translate(0.769287 0.769287)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ProfitabilityActive;
